import { Navigate, Route } from "react-router";
import ComingSoon from "../auth/coming-soon/comingSoon";
import Error404 from "../auth/error/error-404/error400";
import Error500 from "../auth/error/error-500/error500";
import LockScreen from "../auth/lock-screen/lockScreen";
import UnderConstruction from "../auth/underconstruction/underConstruction";
import StudentGroups from "../../views/studentGroups";
import { all_routes } from "./all_routes";

// CLASS LMS COMPONENTS
import Home from "../../views/home/Home";
import Contents from "../../views/contents/Contents";
import Students from "../../views/students";
import Student from "../../views/student";
import ClassroomContents from "../../views/ClassroomContents";
import Reports from "../../views/Reports";

const routes = all_routes;

export const publicRoutes = [
    // CLASS LMS ROUTES
    {
        path: routes.home,
        element: <Home/>,
        route: Route
    },
    {
        path: routes.studentGroups,
        element: <StudentGroups/>,
        route: Route
    },
    {
        path: routes.classroomContents,
        element: <ClassroomContents/>,
        route: Route
    },
    {
        path: routes.students,
        element: <Students/>,
        route: Route
    },
    {
        path: routes.student,
        element: <Student/>,
        route: Route
    },
    {
        path: "/contents",
        element: <Contents/>,
        route: Route
    },
    {
        path: routes.reports,
        element: <Reports/>,
        route: Route
    }

    // THEME ROUTES
    // {
    //     path: "/",
    //     name: "Root",
    //     element: <LoginPage/>,
    //     route: Route,
    // },
];

export const authRoutes = [
    {
        path: routes.lockscreen,
        element: <LockScreen />,
        route: Route,
    },
    {
        path: routes.Error404,
        element: <Error404 />,
        route: Route,
    },
    {
        path: routes.Error500,
        element: <Error500 />,
        route: Route,
    },
    {
        path: routes.underconstruction,
        element: <UnderConstruction />,
        route: Route,
    },
    {
        path: routes.comingSoon,
        element: <ComingSoon />,
        route: Route,
    },
];

